

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import '../style/Product.css';
import Sidebar from '../components/Sidebar';

const tShirts = [


  {
    id: 1,
    name: '190 GSM Oversized T-shirt',
    image: '190GSMWhite.jpg', // Replace with actual path
    Colors: ['Black', 'White'],
    fabric: '100% Cotton',
    products: [

      {
        id: 1,
        name: 'Black Oversized T-shirt',
        title: 'whot',
        images: ['190GSMBlack.jpg', '190GSMBlackB.jpg'],
        description: 'Black Oversized T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 235,
        tax: 'tax',
        mockups: ['190GSMBlack.jpg', '190GSMBlackB.jpg'],
        texture: '21.png',
        GSM: '190 GSM',
        costStructure: {
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4less: 138,
            A4: 114,
            A3: 162,
            full: 198,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        },
        clippingRects: {
          // front: { left: 600, top: 670, width: 1020, height: 1400 },
          front: { left: 540, top: 690, width: 1120, height: 1400 },
          back: { left: 540, top: 690, width: 1120, height: 1400 }
        },  
        print_method: ["DTG", "DTF"],
        sizeChart:'190-regular.jpg',
        sizes : ['S', 'M', 'L', 'XL', 'XXL']
      },
  

      {
        id: 2,
        name: 'White Oversized T-shirt',
        title: 'whot',
        images: ['190GSMWhite.jpg', '190GSMWhiteB.jpg'],
        description: 'White Oversized T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 235,
        tax: 'tax',
        mockups: ['190GSMWhite.jpg', '190GSMWhiteB.jpg'],
        texture: '21.png',
        GSM: '190 GSM',
        costStructure: {
          'DTG': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        },
  
        clippingRects: {
          front: { left: 540, top: 690, width: 1120, height: 1400 },
          back: { left: 540, top: 690, width: 1120, height: 1400 }
        },
  
        print_method: ["DTG", "DTF"],
        sizeChart:'190-regular.jpg',
        sizes : ['S', 'M', 'L', 'XL', 'XXL']
      }, 

    ]
  },



  {
    id: 2,
    name: '220 GSM Oversized T-shirt',
    image: '220GSMWhite.jpg', // Replace with actual path
    Colors: ['Black', 'White'],
    fabric: '100% Cotton',
    products: [

      {
        id: 1,
        name: 'Black Oversized T-shirt',
        title: 'whot',
        images: ['220GSMBlack.jpg', '220GSMBlackB.jpg'],
        description: 'Black Oversized T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 250,
        tax: 'tax',
        mockups: ['220GSMBlack.jpg', '220GSMBlackB.jpg'],
        texture: '21.png',
        GSM: '220 GSM',
        costStructure: { 
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4less: 138,
            A4: 114,
            A3: 162,
            full: 198,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        //   'DTG Brother':{
        //   logo: 60,
        //   LessthenA4: 104,
        //   A4: 175,
        //   A4less: 250,
        //   A3: 250,
        // full: 300,
        // }
      
      },
        clippingRects: {
          front: { left: 530, top: 690, width: 1120, height: 1400 },
          back: { left: 530, top: 690, width: 1120, height: 1400},
        },

        print_method: ["DTG", "DTF"],
        sizeChart:'190-regular.jpg',
        sizes : ['S', 'M', 'L', 'XL']
      },
  

      {
        id: 2,
        name: 'White Oversized T-shirt',
        title: 'whot',
        images: ['220GSMWhite.jpg', '220GSMWhiteB.jpg'],
        description: 'White Oversized T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 250,
        tax: 'tax',
        mockups: ['220GSMWhite.jpg', '220GSMWhiteB.jpg'],
        texture: '21.png',
        GSM: '220 GSM',
        costStructure:{
  
          'DTG': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        //  'DTG Brother':{
        //   logo: 60,
        //   LessthenA4: 104,
        //   A4: 130,
        //   A4less: 200,
        //   A3: 200,
        // full: 250,
        // }
        } ,
        clippingRects: {
          front: { left: 530, top: 690, width: 1120, height: 1400 },
          back: { left: 530, top: 690, width: 1120, height: 1400},
        }, 

        print_method: ["DTG", "DTF"],
        sizeChart:'190-regular.jpg',
        sizes : ['S', 'M', 'L', 'XL']
      },
    ]
  },

  {
    id: 3,
    name: '240 GSM Oversized T-shirt',
    image: 'blackF1.png', // Replace with actual path
    Colors: ['Off-White', 'Black', 'white', 'coffee', 'blue', 'green', 'pink', 'red'],
    fabric: '100% French terry cotton',
    products: [

      {
        id: 1,
        name: 'Off-White Oversized T-shirt',
        title: 'whot',
        images: ['240GSMOfwhiteFront.jpg', '240GSMOfwhiteBack.jpg'],
        description: 'FloralWhite Oversized T-shirt',
        fabric: '100% French terry cotton',
        BASE_COST: 280,
        tax: 'tax',
        mockups: ['240GSMOfwhiteFront.jpg', '240GSMOfwhiteBack.jpg'],
        texture: '21.png',
        GSM: '240 GSM',
        costStructure: {        
          'DTG': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
             A4: 90,
             A3: 120,
            full: 150,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
      },
        clippingRects: {
          front: { left: 530, top: 690, width: 1120, height: 1400 },
          back: { left: 530, top: 690, width: 1120, height: 1400},
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'oversized-tee.jpg',
        sizes : ['S', 'M', 'L', 'XL']
      },

     {
      id: 2,
      name: 'Black Oversized T-shirt',
      title: 'whot',
      images: ['blackF1.png', '3.png'],
      description: 'Black Oversized T-shirt',
      fabric: '100% French terry cotton',
      BASE_COST: 280,
      tax: 'tax',
      mockups: ['blackF1.png', '3.png'],
      texture: '21.png',
      GSM: '240 GSM',
      costStructure: {        
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
      clippingRects: {
        front: { left: 510, top: 690, width: 1120, height: 1400 },
        back: { left: 530, top: 690, width: 1120, height: 1400},
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'oversized-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL']
    },
    
    
       {
      id: 3,
      name: 'White Oversized T-shirt',
      title: 'whot',
      images: ['White240Front.jpg', 'White240Back.jpg'],
      description: 'White Oversized T-shirt',
      fabric: '100% French terry cotton',
      BASE_COST: 280,
      tax: 'tax',
      mockups: ['White240Front.jpg', 'White240Back.jpg'],
      texture: '21.png',
      GSM: '240 GSM',
      costStructure: {        
        'DTG': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
           A4: 90,
           A3: 120,
          full: 150,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
      clippingRects: {
        front: { left: 530, top: 690, width: 1120, height: 1400 },
        back: { left: 530, top: 690, width: 1120, height: 1400},
      },
      print_method: ["DTG", "DTF"],
      sizeChart:'oversized-tee.jpg',
      sizes : ['S', 'M', 'L', 'XL','XXL']
    },

  {
    id: 4,
    name: 'Coffee Oversized T-Shirt',
    title: 'whot',
    images: ['coffeeFront.jpg', 'coffeeBack.jpg'],
    description: 'Saddlebrown Oversized T-Shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['coffeeFront.jpg', 'coffeeBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL']
  },
  {
    id: 5,
    name: 'Royal Blue Oversized T-Shirt',
    title: 'whot',
    images: ['royalblueFront.jpg', 'royalblueBack.jpg'],
    description: 'RoyalBlue Oversized T-Shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['royalblueFront.jpg', 'royalblueBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
      'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL']
  },
  {
    id: 6,
    name: 'Bottle Green Oversized T-Shirt',
    title: 'whot',
    images: ['bottleGreenFront.jpg', 'bottleGreenBack.jpg'],
    description: 'darkgreen Oversized T-Shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['bottleGreenFront.jpg', 'bottleGreenBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
        'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL']
  },


  {
    id: 7,
    name: 'Pink Oversized T-Shirt',
    title: 'whot',
    images: ['pinkFront.jpg', 'pinkBack.jpg'],
    description: 'lightpink Oversized T-Shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['pinkFront.jpg', 'pinkBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
   'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL', 'XXL']
  },


       {
    id: 8,
    name: 'Red Oversized T-shirt',
    title: 'whot',
    images: ['redFront.jpg', 'redBack.jpg'],
    description: 'Red Oversized T-shirt',
    fabric: '100% French terry cotton',
    BASE_COST: 280,
    tax: 'tax',
    mockups: ['redFront.jpg', 'redBack.jpg'],
    texture: '21.png',
    GSM: '240 GSM',
    costStructure: {
   'DTG': {
          logo: 60,
          LessthenA4: 90,
          A4less: 138,
          A4: 114,
          A3: 162,
          full: 198,
        },
        'DTF': {
          logo: 36,
          LessthenA4: 66,
          A4less: 102,
          A4: 90,
          A3: 120,
         full: 150,
        },
    },
    clippingRects: {
      front: { left: 530, top: 690, width: 1120, height: 1400 },
      back: { left: 530, top: 690, width: 1120, height: 1400 }
    },
    print_method: ['DTG', 'DTF'],
    sizeChart: 'oversized-tee.jpg',
    sizes: ['S', 'M', 'L', 'XL', 'XXL']
  },

    ]
  },


  {
    id: 4,
    name: 'Regular Fit T-shirt',
    image: 'BlackFitB.png', // Replace with actual path
    Colors: ['Black', 'White', 'Red', 'Navy Blue'],
    fabric: '100% Cotton',
    products :[
      {
        id: 1,
        name: 'Black Regular Fit T-shirt',
        title: 'wlot',
        images: ['BlackFitF.png', 'BlackFitB.png'],
        description: 'Black Regular Fit T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 180,
        colors: '#000000',
        tax: 'tax',
        mockups: ['BlackFitF.png', 'BlackFitB.png'],
        texture: '21.png',
        GSM: '180 GSM',
        costStructure: {
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4less: 138,
            A4: 114,
            A3: 162,
            full: 198,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        },
        clippingRects: {
          front: { left: 570, top: 750, width: 1067, height: 1333 },
          back: {  left: 570, top: 750, width: 1067, height: 1333 },
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'regularfit-tee.jpg',
        sizes : ['S', 'M', 'L', 'XL', 'XXL']
      },
  
  
      {
        id: 2,
        name: 'White Regular Fit T-shirt',
        title: 'wlot',
        images: ['WhiteFitF.png', 'WhiteFitB.png'],
        description: 'White Regular Fit T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 180,
        tax: 'tax',
        mockups: ['WhiteFitF.png', 'WhiteFitB.png'],
        texture: '21.png',
        GSM: '180 GSM',
        colors: '#FFFFFF', 
        costStructure: {
          'DTG': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
             A4: 90,
             A3: 120,
            full: 150,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        },
        clippingRects: {
          front: { left: 570, top: 750, width: 1067, height: 1333 },
          back: {  left: 570, top: 750, width: 1067, height: 1333 },
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'regularfit-tee.jpg',
        sizes : ['S', 'M', 'L', 'XL', 'XXL']
      },

      {
        id: 3,
        name: 'Red Regular Fit T-shirt',
        title: 'wlot',
        images: ['RedFitF.png', 'RedFitB.png'],
        description: 'Red Regular Fit T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 180,
        tax: 'tax',
        mockups: ['RedFitF.png', 'RedFitB.png'],
        texture: '21.png',
        GSM: '180 GSM',
        colors: '#FF0000',
        costStructure: {
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4less: 138,
            A4: 114,
            A3: 162,
            full: 198,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        },
        clippingRects: {
          front: { left: 570, top: 750, width: 1067, height: 1333 },
          back: {  left: 570, top: 750, width: 1067, height: 1333 },
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'regularfit-tee.jpg',
        sizes : ['S', 'M', 'L', 'XL', 'XXL']
      },
  
      {
        id: 4,
        name: 'Navy Blue Regular Fit T-shirt',
        title: 'wlot',
        images: ['NavyBlueFitF.png', 'NavyBlueFitB.png'],
        description: 'Navy Blue Regular Fit T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 180,
        tax: 'tax',
        mockups: ['NavyBlueFitF.png', 'NavyBlueFitB.png'],
        texture: '21.png',
        GSM: '180 GSM',
        colors: '#000080', 
        costStructure: {
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4less: 138,
            A4: 114,
            A3: 162,
            full: 198,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        },
        clippingRects: {
          front: { left: 570, top: 750, width: 1067, height: 1333 },
          back: {  left: 570, top: 750, width: 1067, height: 1333 },
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'regularfit-tee.jpg',
        sizes : ['S', 'M', 'L', 'XL', 'XXL']
      } ,

      {
        id: 5,
        name: 'Blue Regular Fit T-shirt',
        title: 'wlot',
        images: ['BlueFitF.png', 'BlueFitB.png'],
        description: 'Blue Regular Fit T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 180,
        tax: 'tax',
        mockups: ['BlueFitF.png', 'BlueFitB.png'],
        texture: '21.png',
        GSM: '180 GSM',
        costStructure: {
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4less: 138,
            A4: 114,
            A3: 162,
            full: 198,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        },
        clippingRects: {
          front: { left: 570, top: 750, width: 1067, height: 1333 },
          back: {  left: 570, top: 750, width: 1067, height: 1333 },
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'regularfit-tee.jpg',
        sizes : ['S', 'M', 'L', 'XL', 'XXL']
      },
  
      {
        id: 6,
        name: 'Maroon Regular Fit T-shirt',
        title: 'wlot',
        images: ['BrownFitF.png', 'BrownFitB.png'],
        description: 'Maroon Regular Fit T-shirt',
        fabric: '100% Cotton',
        BASE_COST: 180,
        tax: 'tax',
        mockups: ['BrownFitF.png', 'BrownFitB.png'],
        texture: '21.png',
        GSM: '180 GSM',
        costStructure: {
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4less: 138,
            A4: 114,
            A3: 162,
            full: 198,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
        },
        clippingRects: {
          front: { left: 570, top: 750, width: 1067, height: 1333 },
          back: {  left: 570, top: 750, width: 1067, height: 1333 },
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'regularfit-tee.jpg',
        sizes : ['S', 'M', 'L', 'XL', 'XXL']
      },  

    ]
  },

  {
    id: 5,
    name: 'Baby Tee',
    image: 'BabyTeeB.png', // Replace with actual path
    Colors: ['Black', 'White'],
    fabric: '95% cotton and 5% lycra',
    products: [
      {
        id: 1,
        name: 'Black Baby Tee',
        title: 'baby',
        images: ['BabyTeeB.jpg','BabyTeeB.jpg'],
        description: 'Black Baby Tee',
        fabric: '95% cotton and 5% lycra',
        BASE_COST: 205,
        tax: 'tax',
        mockups: ['BabyTeeB.jpg','BabyTeeB.jpg'],
        texture: '21.png',
        GSM: '190 GSM',
        colors: '#000000', 
        costStructure: {
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4: 114,
            full: 130,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4: 90,
            full: 102,
          },
        },
        clippingRects: {
          front: { left: 540, top: 800, width: 1111.3, height: 1333.3 },
          back: { left: 0, top: 0, width: 0, height: 0 },
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'babyTee-SizeChart.jpg',
        sizes : ['XS','S', 'M', 'L', 'XL','XXL']
      },  

      {
        id: 2,
        name: 'White Baby Tee',
        title: 'baby',
        images: ['BabyTeeW.png','BabyTeeW.png' ],
        description: 'White Baby Tee',
        fabric: '95% cotton and 5% lycra',
        BASE_COST: 205,
        tax: 'tax',
        mockups: ['BabyTeeW.png','BabyTeeW.png'],
        texture: '21.png',
        GSM: '190 GSM',
        colors: '#FFFFFF', 
        costStructure: {
          'DTG': {
            logo: 36,
            LessthenA4: 66,
            A4: 90,
            full: 102,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4: 90,
            full: 102,
          },
        },
        clippingRects: {
          front: { left: 540, top: 800, width: 1111.3, height: 1333.3 },
          back: { left: 0, top: 0, width: 0, height: 0 },
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'babyTee-SizeChart.jpg',
        sizes : ['XS','S', 'M', 'L', 'XL','XXL']
      },  

    ]
  },


  {
    id: 6,
    name: 'Acidwash Oversized T-shirt',
    image: 'AcidWashTee.jpg', // Replace with actual path
    Colors: ['Acidwash'],
    fabric: '100% French terry cotton',
    products: [
      {
        id: 1,
        name: 'Acidwash Oversized T-shirt',
        title: 'whot',
        images: ['AcidWashTee.jpg', 'AcidWashTeeBack.jpg'],
        description: 'Grey Oversized T-shirt',
        fabric: '100% French terry cotton',
        BASE_COST: 350,
        tax: 'tax',
        mockups: ['AcidWashTee.jpg', 'AcidWashTeeBack.jpg'],
        texture: '21.png',
        GSM: '240 GSM',
        costStructure: {        
          'DTG': {
            logo: 60,
            LessthenA4: 90,
            A4less: 138,
            A4: 114,
            A3: 162,
            full: 198,
          },
          'DTF': {
            logo: 36,
            LessthenA4: 66,
            A4less: 102,
            A4: 90,
            A3: 120,
           full: 150,
          },
      },
        clippingRects: {
          front: { left: 530, top: 730, width: 1120, height: 1400 },
          back: { left: 530, top: 690, width: 1120, height: 1400},
        },
        print_method: ["DTG", "DTF"],
        sizeChart:'190-regular.jpg',
        sizes : ['S', 'M', 'L', 'XL','XXL']
      },
    ]
  },


    {
    id: 7,
    name: 'Joggers',
    image: 'joggersFront.jpg', // Replace with actual path
  },

      {
    id: 9,
    name: 'Hoodies',
    image: 'HoodieFront.jpg', // Replace with actual path
  }
  


 
];

const SelectTShirt = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const shop = queryParams.get('shop');

  const handleTShirtClick = (id) => {
    if (id === 7) { // Joggers ID
      navigate('/designjoggers');
    } 
     else if (id === 9) { // Hoodies ID
    navigate('/DesignHoodies');
     }
    else {
      const selectedTShirt = tShirts.find((tShirt) => tShirt.id === id);
      navigate(`/design-uploadNew`, { state: { id: id, tShirts: tShirts } }); // Pass tShirts array
    }
  };
  

  return (
   <div className="flex h-screen bg-gray-50">
  {/* Sidebar */}
  <Sidebar />

  {/* Main content */}
  <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
    <Header />

    <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
          <div className="product-list">
            {tShirts.map((tShirt) => (
              <div
                key={tShirt.id}
                className="product-card"
                onClick={() => handleTShirtClick(tShirt.id)}
              >
                <img src={tShirt.image} alt={tShirt.name} className="product-image" />
                <p className="product-description">{tShirt.name}</p>
                <p className="product-description">{tShirt.fabric}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTShirt;